<template>
  <div>
    <label
        for=""
        class="vs-input--label"
    ><span>{{ label || 'Country' }}</span></label>

    <v-select
        v-model="selected"
        :options="options"
        :placeholder="placeholder"
    ></v-select>
    <div class="con-text-validation span-text-validation vs-input--text-validation-span">
      <span class="span-text-validation">{{ helpText || ''}}</span>
    </div>
    <div v-if="dangerText" class="con-text-validation span-text-validation-danger vs-input--text-validation-span v-enter-to" style="height: 19px;">
      <span class="span-text-validation"> {{ dangerText }} </span>
    </div>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'

  export default {
    name: 'UsersSearch',
    components: {
      vSelect
    },
    props: ['selectedCountry', 'label', 'placeholder', 'helpText', 'dangerText'],
    computed: {
      selected: {
        set (value) {
          this.$emit('selected', value)
        },
        get () {
          return this.selectedCountry
        }
      }
    },
    data () {
      return {
        options: [
          {
            value: 'england',
            label: 'England'},
          {
            value: 'wales',
            label: 'Wales'
          },
          {
            value: 'scotland',
            label: 'Scotland'
          },
          {
            value: 'northern ireland',
            label: 'Northern Ireland'
          }
        ],
      }
    },
  }
</script>
